<cs-header>
  <cs-header-title>{{ LL.dbSnapshots.title() }}</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    @if (snapshots?.length === 0) {
      <cs-card-list-row>
        <cs-note big>{{ LL.dbSnapshots.noSnapshots() }}</cs-note>
      </cs-card-list-row>
    }
    @for (snapshot of snapshots; track snapshot._id) {
      <cs-card>
        <cs-card-title>
          <div class="snapshot-header-row">
            <div class="snapshot-info">
              <cs-label>{{ snapshot.name }}</cs-label>
              <cs-note small>{{ LL.dbSnapshots.snapshotInfo({ date: formatDate(snapshot), count: snapshot.docCount }) }}</cs-note>
            </div>
            <cs-icon-button icon="ellipsis-vertical"
              (click)="handleMoreOptions($event, snapshot)"></cs-icon-button>
          </div>
        </cs-card-title>
      </cs-card>
    }
    <cs-card-list-row>
      <cs-button tertiary icon="add" (click)="handleCreateSnapshot()"
        [label]="LL.dbSnapshots.createSnapshot()"></cs-button>
    </cs-card-list-row>
  </cs-card-list>
</cs-content>
